__turbopack_context__.v({
  "store-search": "HSfx-q_store-search",
  "store-search__btn-wrapper": "HSfx-q_store-search__btn-wrapper",
  "store-search__headline": "HSfx-q_store-search__headline",
  "store-search__icon": "HSfx-q_store-search__icon",
  "store-search__input-wrapper": "HSfx-q_store-search__input-wrapper",
  "store-search__product": "HSfx-q_store-search__product",
  "store-search__product-image": "HSfx-q_store-search__product-image",
  "store-search__product-image-wrapper": "HSfx-q_store-search__product-image-wrapper",
  "store-search__product-info": "HSfx-q_store-search__product-info",
  "store-search__search-form": "HSfx-q_store-search__search-form",
  "store-search__search-input": "HSfx-q_store-search__search-input",
  "store-search__search-message": "HSfx-q_store-search__search-message",
  "store-search__search-results": "HSfx-q_store-search__search-results",
  "store-search__searchbar-row": "HSfx-q_store-search__searchbar-row",
});
